export const LanguageOptions = [
  {
    selected: true,
    value: 'HU',
    label: 'Hungarian',
  },
  {
    value: 'EN',
    label: 'English',
  },
];

export const CurrencyOptions = [
  {
    selected: true,
    value: 'HUF',
    label: 'Huf',
  },
  {
    value: 'EUR',
    label: 'Eur',
  },
];

export const PeriodOptions = [
  {
    selected: true,
    value: 'MONTH',
    label: 'Monthly',
  },
  {
    value: 'QUARTER',
    label: 'Quarterly',
  },
  {
    value: 'HALF',
    label: 'Half',
  },
  {
    value: 'YEAR',
    label: 'Yearly',
  },
];

export const emailTypeOptions = [
  {
    selected: true,
    value: 'promo',
    label: 'Promotion',
  },
  {
    value: 'annual-promo',
    label: 'Annual promo',
  },
];
